import { Input } from "@frui.ts/bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import DateRangeInputControl from "controls/dateRangeInput";
import NumberRangeInputControl from "controls/numberRangeInput";
import { translateGeneral } from "utils/localizations";
import type PaygateReversalViewModel from "viewModels/finance/outgoingPayments/paygateReversalViewModel";
import FilterView from "views/common/filter";
import { onNumberInputKeyPress } from "../../../../utils/numberInput";

const PayGateReversalPaymentFilters: ViewComponent<PaygateReversalViewModel> = observer(({ vm }) => {
  const fullTextClassNames = vm.filter.fullTextSearchEnabled ? "border-success border-2" : "";

  return (
    <FilterView vm={vm}>
      <div className="row">
        <Form.Group as={Col} lg={8} xl={6}>
          <Form.Label>{vm.translateAttribute("authorizedAt")}</Form.Label>
          <DateRangeInputControl target={vm.filter} property="authorizedDate" />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translate("variableSymbolIncomingAndOutgoingPayment")}</Form.Label>
          <Input
            target={vm.filter}
            property="variableSymbol"
            placeholder={translateGeneral("search")}
            type="number"
            onKeyDown={onNumberInputKeyPress}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("cardNumber")}</Form.Label>
          <Input
            target={vm.filter}
            property="cardNumber"
            placeholder={translateGeneral("search")}
            className={fullTextClassNames}
          />
        </Form.Group>
        <Form.Group as={Col} lg={8} xl={6}>
          <Form.Label>{vm.translateAttribute("paidAmount")}</Form.Label>
          <NumberRangeInputControl target={vm.filter} property="paidAmount" min={0} step={0.01} />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("arn")}</Form.Label>
          <Input target={vm.filter} property="arn" className={fullTextClassNames} placeholder={translateGeneral("search")} />
        </Form.Group>
      </div>
    </FilterView>
  );
});

export default PayGateReversalPaymentFilters;
